<template>
    <div class="app-container">
        <div class="care-common-filter">
            <el-form :inline="true" :model="searchForm" label-width="80px" class="care-filter-container" size="small">
                <el-form-item label="创建时间" label-width="70px">
                    <div class="times">
                        <el-date-picker v-model="searchForm.str" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                        </el-date-picker>
                        <span>-</span>
                        <el-date-picker v-model="searchForm.end" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
            </el-form>
            <div class="right-handle">
                <el-button type="primary" size="small" icon="el-icon-search" @click="queryTable">查询</el-button>
            </div>
        </div>
        <div class="operation-area">
            <el-button plain type="primary" size="small" class="el-icon-download" @click="exportProduct">导出明细</el-button>
            <el-button plain type="primary" size="small" class="el-icon-download" @click="exportProductall">导出总表</el-button>
        </div>
        <el-table ref="table" :cell-style="{ 'text-align': 'center' }" :data="tableData"
            :header-cell-style="{ 'text-align': 'center' }" :height="tableHeight" border highlight-current-row
            style="width: 100%">
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <div>{{ new Date(scope.row.create_at).toLocaleString() }}</div>
                </template>
            </el-table-column>
            <el-table-column label="经销商ID" prop="agent_id" />
            <el-table-column label="经销商姓名" prop="agent_name" />
            <el-table-column label="市场积分" prop="team_total" />
            <el-table-column label="个人积分" prop="total" />
            <el-table-column label="市场获奖次数" prop="team_count" />
            <el-table-column label="个人获奖次数" prop="count" />
            <el-table-column label="总次数" prop="total_count" />
        </el-table>
        <pagination style="width: 100%;height: 100px;" :total="total" :skip.sync="pg.skip" :limit.sync="pg.limit"
            @pagination="queryTable" />
    </div>
</template>
    
<script>
import xlsx from 'xlsx'
import axios from 'axios'
export default {
    data() {
        return {
            tableHeight: window.innerHeight - 350,
            searchForm: {
                str: '',
                end: ''
            },
            tableData: [],
            pg: { limit: 10, skip: 0 },
            total: 0,
            page: 0,
        }
    },
    created() {
        this.queryTable()
    },
    methods: {
        // 获取数据
        queryTable() {
            let { str, end } = this.searchForm
            str = str ? str : ''
            end = end ? end : ''
            axios.get('https://app.hkaspire.cn/report/public/egg/summarizing_list?start_time=' + str + '&end_time=' + end +
                "&limit=" + this.pg.limit + "&skip=" + this.pg.skip)
                .then(res => {
                    this.tableData = res.data.data
                    this.total = res.data.changes
                })
        },
        //导出明细
        exportProduct() {
            let { str, end } = this.searchForm
            str = str ? str : ''
            end = end ? end : ''
            axios.get('https://app.hkaspire.cn/report/public/egg/list?start_time=' + str + '&end_time=' + end).then((res) => {
                if (res.data.data != null) {
                    const data = [
                        [
                            '创建时间',
                            '经销商ID',
                            '经销商姓名',
                            '市场积分',
                            '个人积分',
                            '市场获奖次数',
                            '个人获奖次数',
                            '总次数',
                        ]
                    ]
                    res.data.data.forEach((ele) => {
                        ele.create_at = new Date(ele.create_at).toLocaleString()
                        data.push([
                            ele.create_at,
                            ele.agent_id,
                            ele.agent_name,
                            ele.count,
                            ele.count,
                            ele.count,
                            ele.count,
                            ele.total_count,
                        ])
                    })
                    const wb = xlsx.utils.book_new()
                    const ws = xlsx.utils.aoa_to_sheet(data)
                    xlsx.utils.book_append_sheet(wb, ws, '砸蛋明细表')
                    xlsx.writeFile(wb, '砸蛋明细表' + new Date().valueOf() + '.xlsx')
                } else {
                    this.$message.error('暂无数据')
                }
            })
        },
        async exportProductall() {
            let { str, end } = this.searchForm
            str = str ? str : ''
            end = end ? end : ''
            let resdata = await axios.get('https://app.hkaspire.cn/report/public/egg/summarizing_list?start_time=' + str + '&end_time=' + end)
            // var map =this.arrayToMap(resdata.data.data);
            // var arrayList = this.mapToArray(map);
            // let newlist = arrayList.map((item) => {
            //     return item[0]
            // })
            // console.log(newlist, 'newlist')
            if (resdata.data.data != null) {
                const data = [
                    [
                        '经销商ID',
                        '经销商姓名',
                        '市场获奖次数',
                        '个人获奖次数',
                        '总次数',
                    ]
                ]
                resdata.data.data.forEach((ele) => {
                    data.push([
                        ele.agent_id,
                        ele.agent_name,
                        ele.team_count,
                        ele.count,
                        ele.total_count
,
                    ])
                })
                const wb = xlsx.utils.book_new()
                const ws = xlsx.utils.aoa_to_sheet(data)
                xlsx.utils.book_append_sheet(wb, ws, '砸蛋汇总表')
                xlsx.writeFile(wb, '砸蛋汇总表' + new Date().valueOf() + '.xlsx')
            } else {
                this.$message.error('暂无数据')
            }
        },
        arrayToMap(data) {
            if (!data instanceof Array || data.length == 0) {
                return {};
            }
            var map = {};
            for (var i = 0; i < data.length; i++) {
                if (!data[i] instanceof Array || data.length < 2) {
                    continue;
                }
                var agent_name = data[i].agent_name;
                if (agent_name != undefined) {
                    if (map[agent_name] == undefined) {
                        map[agent_name] = [];
                    }
                    map[agent_name].push(data[i]);
                }
            }
            return map;
        },
        //把map转成数组
        mapToArray(data) {
            if (data == undefined) {
                return [];
            }
            var array = [];
            for (var p in data) {
                array.push(data[p]);
            }
            return array;
        }

    }
}
</script>
    
<style scoped lang="scss">
.app-container {
    padding: 20px;
    box-sizing: border-box;
    height: 100%;
    overflow: scroll;
    background: #f2f2f2;
}

.care-common-filter {
    background-color: #fff;
    padding: 20px;
    display: flex;
}

.operation-area {
    margin: 10px 0;
}
</style>
    


// WEBPACK FOOTER //
// src/views/datalist.vue